import { getTeamMemberAPI, getTeamsAPI } from '@constants';
import { RootState } from '@redux/hooks';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IAccount, IMemberDetails } from '@types';
import axios from 'axios';

export const fetchTeams = createAsyncThunk<
  IAccount,
  { force?: boolean } | void
>(
  'teams/fetchTeams',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get<IAccount>(getTeamsAPI(), {
        withCredentials: true,
      });
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || err);
    }
  },
  {
    condition: (arg, { getState }) => {
      if (arg?.force) return true;
      const { data, apiStatus } = (getState() as RootState).teams;
      return !data && apiStatus !== 'loading';
    },
  },
);

export const loadMemberDetails = createAsyncThunk<
  IMemberDetails,
  { teamId: string; memberId: string }
>(
  'teams/loadMemberDetails',
  async ({ teamId, memberId }) => {
    const response = await axios.get<IMemberDetails>(
      getTeamMemberAPI(teamId, memberId),
      { withCredentials: true },
    );
    return response.data;
  },
  {
    condition: ({ memberId }, { getState }) => {
      const { memberDetails } = (getState() as RootState).teams;
      return (
        !memberDetails.data ||
        memberDetails.data.member.id !== memberId ||
        memberDetails.apiStatus !== 'loading'
      );
    },
  },
);
